export default function ApplicationGuide() {
  const requirements = [
    {
      icon: 'ri-user-line',
      title: '申込み条件',
      items: [
        '18歳以上29歳以下の方',
        '学生（大学生・短大生・専門学校生・大学院生）',
        '未成年の場合は親権者の同意が必要',
        '日本国内に住所があること'
      ]
    },
    {
      icon: 'ri-file-text-line',
      title: '必要書類',
      items: [
        '本人確認書類（運転免許証・マイナンバーカード等）',
        '学生証（在学証明書）※学生の場合',
        '銀行口座情報（引き落とし口座）',
        '親権者同意書（未成年の場合）'
      ]
    },
    {
      icon: 'ri-bank-card-line',
      title: '審査のポイント',
      items: [
        '学生・若年層向けカードは審査が通りやすい',
        'アルバイト収入や正社員収入でOK',
        '学生の場合は親の信用情報が参考にされる場合あり',
        '複数枚同時申込みは避ける'
      ]
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h3 className="text-3xl font-bold text-center mb-4 text-[#003366]">
          学生・29歳以下がクレジットカードを作る際の申込み条件
        </h3>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          学生や29歳以下の方がクレジットカードを申し込む際に必要な条件や書類を確認しましょう。事前準備をしっかり行えば、スムーズに審査が進みます。
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {requirements.map((req, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#14B8A6] to-[#0F9B8E] rounded-full flex items-center justify-center mb-4">
                <i className={`${req.icon} text-white text-2xl w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h4 className="text-xl font-bold mb-4 text-[#003366]">{req.title}</h4>
              <ul className="space-y-3">
                {req.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-[#14B8A6] text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 注意点セクション */}
        <div className="bg-white rounded-xl p-8 shadow-md">
          <h4 className="text-2xl font-bold mb-6 text-[#003366] flex items-center gap-3">
            <i className="ri-alert-line text-[#14B8A6] text-3xl w-8 h-8 flex items-center justify-center"></i>
            学生・29歳以下がカードを作る際の注意点
          </h4>
          
          <div className="space-y-6">
            <div className="border-l-4 border-[#14B8A6] pl-6">
              <h5 className="font-bold text-lg mb-2 text-[#003366]">親権者の同意について</h5>
              <p className="text-gray-700 leading-relaxed">
                18歳・19歳の未成年者がクレジットカードを申し込む場合、親権者の同意が必要です。カード会社から親権者に電話確認が入る場合があるため、事前に保護者に相談しておきましょう。20歳以上の方は親権者の同意は不要です。
              </p>
            </div>

            <div className="border-l-4 border-[#14B8A6] pl-6">
              <h5 className="font-bold text-lg mb-2 text-[#003366]">利用限度額について</h5>
              <p className="text-gray-700 leading-relaxed">
                学生向けクレジットカードの利用限度額は、通常10万円〜30万円程度に設定されます。社会人の29歳以下の方は収入に応じて30万円〜50万円程度になることもあります。使いすぎを防ぐための配慮として、最初は低めに設定されることが多いです。
              </p>
            </div>

            <div className="border-l-4 border-[#14B8A6] pl-6">
              <h5 className="font-bold text-lg mb-2 text-[#003366]">在学証明について（学生の場合）</h5>
              <p className="text-gray-700 leading-relaxed">
                学生の場合、学生証のコピーや在学証明書の提出が必要な場合があります。オンライン申込みの場合は、スマホで撮影した学生証の画像をアップロードするだけで完了するケースが多いです。社会人の方は収入証明書が必要になる場合があります。
              </p>
            </div>

            <div className="border-l-4 border-[#14B8A6] pl-6">
              <h5 className="font-bold text-lg mb-2 text-[#003366]">卒業後・30歳以降の取り扱い</h5>
              <p className="text-gray-700 leading-relaxed">
                卒業後や30歳以降は自動的に一般カードに切り替わります。若い時代の利用実績が信用情報として残るため、将来のローン審査などで有利になります。年会費が発生するカードもあるため、切り替え前に確認しておきましょう。
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="#ranking"
            className="inline-block bg-[#14B8A6] text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#0F9B8E] transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            学生・29歳以下向けカードを今すぐチェック
          </a>
        </div>
      </div>
    </section>
  );
}